import { render, staticRenderFns } from "./RelatorioFinanceiro.vue?vue&type=template&id=5594db2c&"
import script from "./RelatorioFinanceiro.vue?vue&type=script&lang=js&"
export * from "./RelatorioFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports